var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m47.11 59.48-10.75 4.57-6.435-14.44-11.74 4.993 0.04766-46.65 35.58 31.5-13.14 5.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0cfce",
    d: "m44.61 43.87 9.207-4.416-35.58-31.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m18.21 7.95 35.64 31.5-13.16 5.586 6.445 14.44-10.77 4.57-6.445-14.44-11.76 4.993z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCursor);
export default __webpack_public_path__ + "static/media/defaultCursor.b16560d418ef45ec9c5f9f348f825762.svg";
export { ForwardRef as ReactComponent };